import { Action, createReducer, on } from '@ngrx/store';
import { Popups, PopupsDTO, PopupsFilters } from '../../commons/models/popups';
import * as PopupsActions from '../actions/popups.actions';

export interface PopupState {
    list: PopupsDTO[];
    total: number;
    includes: string[];
    currentPage: number;
    perPage: number;
    order: string;
    direction: string;
    filters: PopupsFilters;
    dialogId: string;
    selectionDialogId: string;
    popup: PopupsDTO;
    selectedPopups: Popups[];
};

const initialState: PopupState = {
    list: [],
    total: 0,
    includes: [],
    currentPage: 1,
    perPage: 25,
    order: null,
    direction: null,
    filters: null,
    dialogId: null,
    selectionDialogId: null,
    popup: null,
    selectedPopups: []
};

const popupsReducer = createReducer(
    initialState,
    on(PopupsActions.loadPopupsCompleted, (state, {popups, currentPage, total, perPage, order, direction, filters, includes}) => {
        return { ...state, list: popups, currentPage, total, perPage, order, direction, filters, includes };
    }),
    on(PopupsActions.popupDialogOpened, (state, { dialogId }) => ({
        ...state,
        dialogId,
    })),
);

export function reducer(state: PopupState | undefined, action: Action){
    return popupsReducer(state, action);
}

